import contract from '@mailobj-browser/front/js/contracts/contract.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import close from './close/close.js'
import list from './list/list.js'
import selectable from './selectable/selectable.js'

export default contract({
  close: array([
    close
  ]),
  list: array([
    list
  ]),
  selectable
})